import { api_configs } from "src/api-services";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getBreaktime = createAsyncThunk(
    'empbreakdata/getBreaktime',
    async (payload) => {
        try {
            // Simulating async operation, returning dummy data after a delay
            const res = await axios({
                method: "GET",
                url: `${api_configs.employeeBreaktimeList}?userId=${payload.userIDdata}&createdAtDate=${payload.searchBydate}&yearName=${payload.yearName}&monthName=${payload.monthName}`,
                // headers: {
                //     token: window.localStorage.getItem("token")
                // }
            });
            if (res.data.responseCode === 200) {
                return res.data.result;
            }
            // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulating delay
            // return cardDetails.data; // Return dummy data directly
        } catch (error) {
            throw error; // Let the rejection handle in createSlice catch this
        }
    }
);

// Slice for products
const EmpbreakSlice = createSlice({
    name: 'empbreakdata',
    initialState: { isLoading: false, breaktimelist: [], error: null },
    extraReducers: (builder) => {
        builder
            .addCase(getBreaktime.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getBreaktime.fulfilled, (state, action) => {
                state.isLoading = false;
                state.breaktimelist = action.payload;
                state.error = null;
            })
            .addCase(getBreaktime.rejected, (state, action) => {
                state.isLoading = false;
                state.breaktimelist = [];
                state.error = action.error.message; // Access error message
            });
    },
});



// Selectors to access state from Redux store
export const selectBreaktimelist = (state) => state.empbreakdata.breaktimelist;

// Exporting reducers
export default EmpbreakSlice.reducer;